import { eTargetType } from "./TargetType";



export abstract class TargetSettingsBase {
    get type(): eTargetType { return this._type; }
    protected _type: eTargetType;
    /**
     * (RO) Zvetseni terce oproti zakladni velikosti.
     */
    get scale(): number { return this._scale; }
    protected _scale: number;
    /**
     * Pouzije velikost predchoziho terce v seznamu pro vypocet pozice na X
     */
    static readonly FLAG_USE_PREV_TARGET_SIZE_FOR_X = 0x0004;
    /**
     * Pouzije velikost predchoziho terce v seznamu pro vypocet pozice na Y
     */
    static readonly FLAG_USE_PREV_TARGET_SIZE_FOR_Y = 0x0008;
    /**
     * Pouzije se pozice predchoziho terce na ose X (pozice predchoziho terce se ziska pri inicializaci noveho terce)
     */
    static readonly FLAG_USE_PREV_TARGET_X = 0x0010;
    /**
     * Pouzije se pozice predchoziho terce na ose X (pozice predchoziho terce se ziska pri inicializaci noveho terce)
     */
    static readonly FLAG_USE_PREV_TARGET_Y = 0x0020;
    /**
     * Pozice na ose X je offset od pozice X predchoziho terce
     */
    static readonly FLAG_OFFSET_FROM_PREV_TARGET_X = 0x0040;
    /**
     * Pozice na ose Y je offset od pozice Y predchoziho terce
     */
    static readonly FLAG_OFFSET_FROM_PREV_TARGET_Y = 0x0080;

    get flags(): number { return this._flags; }
    protected _flags: number;

    /**
     * (RO) True, pokud se ma pouzit velikost predchoziho terce v seznamu pro vypocet pozice na X
     */
    get usePrevTargetSizeForX(): boolean { return (this._flags & TargetSettingsBase.FLAG_USE_PREV_TARGET_SIZE_FOR_X) != 0; }
    /**
     * (RO) True, pokud se ma pouzit velikost predchoziho terce v seznamu pro vypocet pozice na Y
     */
    get usePrevTargetSizeForY(): boolean { return (this._flags & TargetSettingsBase.FLAG_USE_PREV_TARGET_SIZE_FOR_Y) != 0; }
    /**
     * (RO) True, pokud se ma pouzit pozice predchoziho terce na ose X (pozice predchoziho terce se ziska pri inicializaci noveho terce)
     */
    get usePrevTargetX(): boolean { return (this._flags & TargetSettingsBase.FLAG_USE_PREV_TARGET_X) != 0; }
    /**
     * (RO) True, pokud se ma pouzit pozice predchoziho terce na ose Y (pozice predchoziho terce se ziska pri inicializaci noveho terce)
     */
    get usePrevTargetY(): boolean { return (this._flags & TargetSettingsBase.FLAG_USE_PREV_TARGET_Y) != 0; }

    //-------------------------------------------------------------------------    
    //-------------------------------------------------------------------------
    constructor(type: eTargetType, scale: number, flags: number = 0) {
        if (scale <= 0)
            scale = 1;

        this._scale = scale;
        this._type = type;
        this._flags = flags;
    }
}